export default function (app) {
  const sentry = app.get('sentryClient');
  class Notifs {
    requestPermission = () => {
      if (!('Notification' in window)) {
        console.error('This browser does not support notifications');
        return;
      }
      return Notification.requestPermission();
    };
    notify = async (message, opts) => {
      if (!('Notification' in window)) {
        console.error('This browser does not support notifications');
        return;
      }

      const options = {
        // TODO: Add some defaults like icon, image, etc
        ...opts
      };

      var notification;

      if (Notification.permission === 'granted') {
        try {
          // Chrome for Android throws errors.
          // Failed to construct 'Notification': Illegal constructor. Use ServiceWorkerRegistration.showNotification() instead.
          // TODO: Update this to try to use SW notifs and gracefully
          // fallback or no-op this.
          notification = new Notification(message, options);
        } catch (error) {
          sentry.captureException(error);
        }
      } else {
        // else if (Notification.permission !== 'denied')
        const permission = await this.requestPermission();
        if (permission === 'granted') {
          try {
            // Chrome for Android throws errors.
            // Failed to construct 'Notification': Illegal constructor. Use ServiceWorkerRegistration.showNotification() instead.
            // TODO: Update this to try to use SW notifs and gracefully
            // fallback or no-op this.
            notification = new Notification(message, options);
          } catch (error) {
            sentry.captureException(error);
          }
        } else {
          return;
        }
      }

      if (!notification) {
        return;
      }

      notification.addEventListener('click', function (event) {
        event.preventDefault();
        window.focus();
        notification.close();
      });

      return notification;
    };
  }
  app.set('notifications', new Notifs());
}
